<template>
    <div>
        <v-card>
            <v-card-title class="pb-0 headline">Filtro de asistencias</v-card-title>
            <v-card-text class="pt-0">
                <v-flex xs12 sm12>
                    <v-alert
                        v-model="showErrorDataLoadedAlert"
                        type="error"
                        dismissible
                        transition="scale-transition"
                        dark
                    >
                        No se han podido cargar todos los datos necesarios para este filtro.
                        <br />
                        Intente cargar el filtro nuevamente.
                    </v-alert>

                    <template>
                        <v-container style="max-width: 500px" class="pa-1">
                            <v-autocomplete
                                v-model="selectedCampos"
                                class="pt-0"
                                :items="computerInputs"
                                item-value="text"
                                return-object
                                hide-selected
                                placeholder="Selecciones los campos para filtrar..."
                                multiple
                                persistent-hint
                                deletable-chips
                                small-chips
                                dense
                                clearable
                                tags
                                ref="selectedCamposRef"
                            >
                            </v-autocomplete>

                            <v-divider></v-divider>

                            <v-flex class="my-1" align="center">
                                <v-layout>
                                    <v-fade-transition leave-absolute>
                                        <strong class="mx-4 my-1 black--text">
                                            Filtros: {{ selectedCampos.length }}
                                        </strong>
                                    </v-fade-transition>
                                    <v-fade-transition leave-absolute>
                                        <strong class="mx-4 my-1 green--text"> Activos: {{ activeFilters }} </strong>
                                    </v-fade-transition>

                                    <v-spacer></v-spacer>

                                    <v-btn color="success" small class="my-0" @click="applyFilter()">
                                        Aplicar
                                    </v-btn>
                                </v-layout>
                            </v-flex>

                            <v-divider class="mb-4"></v-divider>

                            <v-card v-if="selectedCampos.length > 0">
                                <v-list>
                                    <v-slide-y-transition class="py-0" group tag="v-list">
                                        <template v-for="(campo, i) in selectedCampos">
                                            <v-divider v-if="i !== 0" :key="`${i}-divider`" class="pb-0"></v-divider>
                                            <v-list-tile :key="campo.id">
                                                <v-list-tile-action>
                                                    <v-checkbox
                                                        v-model="campo.activo"
                                                        :disabled="selectedCampos[i].value.length === 0"
                                                        color="info"
                                                        class="mt-3"
                                                    >
                                                    </v-checkbox>
                                                </v-list-tile-action>

                                                <v-list-tile-content>
                                                    <template v-if="campo.text === 'Empleado'">
                                                        <v-autocomplete
                                                            v-model="selectedCampos[i].value"
                                                            label="Empleado"
                                                            :items="EMPLEADOS"
                                                            item-text="nombre"
                                                            item-value="id"
                                                            :filter="customFilter"
                                                            hide-no-data
                                                            hide-selected
                                                            class="mt-3"
                                                        >
                                                            <template v-slot:item="data">
                                                                <v-list-tile-content>
                                                                    <v-list-tile-title
                                                                        v-html="
                                                                            data.item.nombre +
                                                                                ' ' +
                                                                                data.item.apellido_paterno +
                                                                                ' ' +
                                                                                data.item.apellido_materno
                                                                        "
                                                                    >
                                                                    </v-list-tile-title>
                                                                </v-list-tile-content>
                                                            </template>
                                                            <template v-slot:selection="data">
                                                                {{
                                                                    data.item.nombre +
                                                                        " " +
                                                                        data.item.apellido_paterno +
                                                                        " " +
                                                                        data.item.apellido_materno
                                                                }}
                                                            </template>
                                                        </v-autocomplete>
                                                    </template>

                                                    <template v-if="campo.text === 'Fecha'">
                                                        <v-menu
                                                            ref="menuFecha"
                                                            v-model="menuFecha"
                                                            :close-on-content-click="false"
                                                            :nudge-right="40"
                                                            lazy
                                                            transition="scale-transition"
                                                            offset-y
                                                            full-width
                                                            :disabled="
                                                                asistenciaGroupBy === '2' || asistenciaGroupBy === '5'
                                                            "
                                                            min-width="290px"
                                                        >
                                                            <template v-slot:activator="{ on }">
                                                                <v-text-field
                                                                    v-model="computedFechaFormatted"
                                                                    label="Fecha"
                                                                    readonly
                                                                    :disabled="
                                                                        asistenciaGroupBy === '2' ||
                                                                            asistenciaGroupBy === '5'
                                                                    "
                                                                    v-on="on"
                                                                    class="mt-3"
                                                                    @blur="
                                                                        dateFecha = parseDate(selectedCampos[i].value)
                                                                    "
                                                                >
                                                                </v-text-field>
                                                            </template>
                                                            <v-date-picker
                                                                v-model="dateFecha"
                                                                no-title
                                                                scrollable
                                                                @input="menuFecha = false"
                                                            >
                                                            </v-date-picker>
                                                        </v-menu>
                                                    </template>

                                                    <template v-if="campo.text === 'Rango de fecha'">
                                                        <v-daterange
                                                            v-model="inputs[campo.id - 1].value"
                                                            start-label="d/m/a"
                                                            end-label="d/m/a"
                                                            separator-label="-"
                                                            preset-label="Prestablecidos"
                                                            locale="es"
                                                            display-format="dd/MM/yyyy"
                                                            label="Rango*"
                                                            :presets="presets"
                                                            :input-props="{
                                                                label: 'Rango',
                                                                style: { width: '245px' },
                                                                class: 'mt-3'
                                                            }"
                                                            :action-labels="{
                                                                apply: 'Aplicar',
                                                                cancel: 'Cancelar',
                                                                reset: 'Resetear'
                                                            }"
                                                            :disabled="
                                                                asistenciaGroupBy === '2' || asistenciaGroupBy === '5'
                                                            "
                                                        ></v-daterange>
                                                    </template>

                                                    <template v-if="campo.text === 'Campus'">
                                                        <v-select
                                                            v-model="inputs[campo.id - 1].value"
                                                            :items="CAMPUS"
                                                            label="Campus"
                                                            item-text="nombre"
                                                            item-value="id"
                                                            class="mt-3"
                                                        >
                                                        </v-select>
                                                    </template>

                                                    <template v-if="campo.text === 'Sección'">
                                                        <v-select
                                                            v-if="inputs[1].value !== ''"
                                                            v-model="inputs[campo.id - 1].value"
                                                            :items="
                                                                SECCIONES.filter(el => el.campus_id === inputs[1].value)
                                                            "
                                                            label="Sección"
                                                            item-text="nombre"
                                                            item-value="id"
                                                            class="mt-3"
                                                        >
                                                        </v-select>
                                                        <v-card-text class="mt-3" v-else>
                                                            Seleccione el campus
                                                        </v-card-text>
                                                    </template>

                                                    <template v-if="campo.text === 'Departamento'">
                                                        <v-select
                                                            v-model="inputs[campo.id - 1].value"
                                                            :items="DEPARTAMENTOS"
                                                            label="Departamento"
                                                            item-text="nombre"
                                                            item-value="id"
                                                            class="mt-3"
                                                        >
                                                        </v-select>
                                                    </template>
                                                </v-list-tile-content>

                                                <v-spacer></v-spacer>

                                                <v-scroll-x-transition>
                                                    <v-icon v-if="campo.activo" color="success">
                                                        fa-check
                                                    </v-icon>
                                                </v-scroll-x-transition>
                                            </v-list-tile>
                                        </template>
                                    </v-slide-y-transition>
                                </v-list>
                            </v-card>
                        </v-container>
                    </template>
                </v-flex>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import Util from "@/util"
import { mapGetters } from "vuex"
import { VDaterange } from "vuetify-daterange-picker"
import "vuetify-daterange-picker/dist/vuetify-daterange-picker.css"
import { format, subDays } from "date-fns"

export default {
    name: "CustomFilterAsistencia",
    components: { VDaterange },
    props: {
        asistenciaGroupBy: { type: String, default: null },
        internalState: { type: Object, default: null }
    },
    data: () => ({
        inputs: Util.AsistenciaCampos(),
        selectedCampos: [],

        //fecha solicitud
        menuFecha: false,
        dateFecha: new Date().toISOString().substr(0, 10),

        //saber si se cargaron todos los datos necesarios para seleccionar
        showErrorDataLoadedAlert: false,

        //rangos prestablecidos
        presets: [
            {
                label: "Últimos 30 días",
                range: [format(subDays(new Date(), 30), "yyyy-MM-dd"), format(subDays(new Date(), 1), "yyyy-MM-dd")]
            },
            {
                label: "Hoy",
                range: [format(new Date(), "yyyy-MM-dd"), format(new Date(), "yyyy-MM-dd")]
            },
            {
                label: "Ayer",
                range: [format(subDays(new Date(), 1), "yyyy-MM-dd"), format(subDays(new Date(), 1), "yyyy-MM-dd")]
            }
        ]
    }),
    methods: {
        applyFilter() {
            let customFilter = ""
            this.selectedCampos.forEach(campo => {
                if (campo.activo) {
                    if (campo.attribute === "fecha") {
                        customFilter = customFilter + `${campo.attribute}=${this.parseDate(campo.value)}&`
                    } else if (campo.attribute === "rango_fecha") {
                        customFilter =
                            customFilter + `${campo.attribute}=${campo.value.start} hasta ${campo.value.end}&`
                    } else {
                        customFilter = customFilter + `${campo.attribute}=${campo.value}&`
                    }
                }
            })
            customFilter = customFilter.slice(0, -1)
            return this.$emit("applyFilter", {
                customFilter: customFilter,
                activeFilters: this.activeFilters,
                filterAsistenciaTotales: this.asistenciaGroupBy === "2" || this.asistenciaGroupBy === "5",
                internalState: {
                    inputs: this.inputs,
                    selectedCampos: this.selectedCampos
                }
            })
        },

        formatDate(date) {
            if (!date) return null

            const [year, month, day] = date.split("-")
            return `${day}/${month}/${year}`
        },

        parseDate(date) {
            if (!date) return null

            const [day, month, year] = date.split("/")
            return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`
        },

        customFilter(item, queryText) {
            const textNombre = item.nombre.toLowerCase()
            const textApellidoPaterno = item.apellido_paterno.toLowerCase()
            const textApellidoMaterno = item.apellido_materno.toLowerCase()
            const searchText = queryText.toLowerCase()

            return (
                textNombre.indexOf(searchText) > -1 ||
                textApellidoPaterno.indexOf(searchText) > -1 ||
                textApellidoMaterno.indexOf(searchText) > -1
            )
        }
    },

    computed: {
        activeFilters() {
            return this.selectedCampos.filter(campo => campo.activo).length
        },

        ...mapGetters(["EMPLEADOS", "CAMPUS", "SECCIONES", "DEPARTAMENTOS"]),

        computedFechaFormatted() {
            this.inputs[4].value = this.formatDate(this.dateFecha)
            return this.formatDate(this.dateFecha)
        },

        computerInputs() {
            let newInputs = []
            this.inputs.forEach(el => {
                let newElement = el
                newElement.disabled =
                    (el.attribute === "fecha" || el.attribute === "rango_fecha") &&
                    (this.asistenciaGroupBy === "2" || this.asistenciaGroupBy === "5")
                newInputs.push(newElement)
            })
            return newInputs
        }
    },

    watch: {
        selectedCampos() {
            setTimeout(() => {
                this.$refs.selectedCamposRef.isMenuActive = false
            }, 50)
        }
    },

    mounted() {
        this.$store.dispatch("LOAD_ALL_EMPLEADOS").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
        this.$store.dispatch("LOAD_ALL_CAMPUS").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
        this.$store.dispatch("LOAD_ALL_SECCIONES").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
        this.$store.dispatch("LOAD_ALL_DEPARTAMENTOS").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })

        if (this.internalState) {
            this.selectedCampos = this.internalState.selectedCampos
            this.inputs = this.internalState.inputs
        }
    }
}
</script>

<style scoped>
.v-alert {
    padding-top: 3px;
    padding-bottom: 4px;
    margin-top: 1px;
    margin-left: 2px;
    margin-right: 2px;
}
</style>
